import React, { createContext } from "react";

interface NavBarConfig {
  open: boolean;
  projectsExpanded: boolean;
  globalExpanded: boolean;
  showCompanySwitcher: boolean;
  company?: Company;
}

export const defaultNavBarConfig: NavBarConfig = {
  open: false,
  projectsExpanded: false,
  globalExpanded: false,
  showCompanySwitcher: false,
  company: undefined,
};

export const NavBarContext = createContext<NavBarConfig>(defaultNavBarConfig);
export const NavBarDispatchContext = createContext<React.Dispatch<Action>>(
  () => {
    /* empty */
  },
);

type Action = {
  type:
    | "open"
    | "openProject"
    | "openGlobal"
    | "close"
    | "closeProject"
    | "closeGlobal"
    | "showCompanySwitcher"
    | "setCompany";
  company?: Company;
};

export function navBarReducer(
  config: NavBarConfig,
  action: Action,
): NavBarConfig {
  switch (action.type) {
    case "open": {
      return { ...config, open: true };
    }
    case "close": {
      return { ...config, open: false };
    }
    case "openProject": {
      return { ...config, open: true, projectsExpanded: true };
    }
    case "openGlobal": {
      return { ...config, open: true, globalExpanded: true };
    }
    case "closeProject": {
      return { ...config, projectsExpanded: false };
    }
    case "closeGlobal": {
      return { ...config, globalExpanded: false };
    }
    case "showCompanySwitcher": {
      return { ...config, showCompanySwitcher: true };
    }
    case "setCompany": {
      return { ...config, company: action.company };
    }
    default: {
      return defaultNavBarConfig;
    }
  }
}
